import { UseMutateAsyncFunction, useMutation, useQueryClient } from "@tanstack/react-query"
import { LIST_USER_INVITATIONS, LIST_USER_WORKSPACES_KEY, USER_DETAILS_KEY } from "../../../constants"
import { VerifyWorkspaceInvite } from "../../../types"
import { TriggerToast } from "../../globals/Toaster"
import { useWorkspaceService } from "../services/useWorkspaceService"
import { invalidateActivityQueries } from "../../../utils/queryInvalidation"

type AcceptInviteProps = {
  inviteId: string
}

type UseAcceptInviteType = UseMutateAsyncFunction<VerifyWorkspaceInvite, unknown, AcceptInviteProps, unknown>

const useAcceptInvite = (): UseAcceptInviteType => {

  const queryClient = useQueryClient()
  const workspaceService = useWorkspaceService()

  const { mutateAsync: acceptInviteMutation } = useMutation({
    mutationFn: async (params: AcceptInviteProps) => {
      return workspaceService.verifyWorkspaceInvite(params.inviteId)
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [LIST_USER_INVITATIONS], refetchType: "active" }),
        queryClient.invalidateQueries({ queryKey: [LIST_USER_WORKSPACES_KEY], refetchType: "active" }),
        queryClient.invalidateQueries({ queryKey: [USER_DETAILS_KEY], refetchType: "active" }),
        invalidateActivityQueries(queryClient),
      ])
      TriggerToast("Workspace invite accepted successfully.", undefined, 'success')
    },
    onError: () => {
      TriggerToast("Failed to accept workspace invite.", undefined, 'error')
    },
  })

  return acceptInviteMutation
}

export default useAcceptInvite
